<div class="sticky-header">
    <button
        mat-icon-button
        type="button"
        (click)="toggleFieldEditing()"
        [attr.aria-label]="
            isFieldEditingEnabled
                ? 'Disable Field Editing'
                : 'Enable Field Editing'
        "
        [title]="
            isFieldEditingEnabled
                ? 'Disable Field Editing'
                : 'Enable Field Editing'
        "
    >
        <mat-icon>{{ isFieldEditingEnabled ? "lock_open" : "lock" }}</mat-icon>
    </button>
    <span class="edit-status-text">
        {{
            isFieldEditingEnabled
                ? "Field editing enabled"
                : "Click to enable Field editing"
        }}
    </span>
</div>

<form [formGroup]="form" (ngSubmit)="formlySubmit(model)">
    <div class="row">
        <div class="col-md-12">
            <p class="section-label"><strong>Error Categories</strong></p>
            <p>{{ errorCategories?.join(", ") }}</p>
            <formly-form
                [form]="form"
                [fields]="fields"
                [model]="model"
                [options]="formlyOptions"
            ></formly-form>
        </div>
    </div>

    <app-reasoning-group [items]="reasoningItems"></app-reasoning-group>

    <div class="modal-bottom-toolbar">
        <button mat-button type="button" (click)="cancelClicked()">
            Cancel
        </button>
        <button
            *ngIf="allowedToUpdate"
            mat-flat-button
            type="button"
            (click)="sendEmailClicked()"
        >
            Send Email
        </button>
        <button
            *ngIf="!errorIsArchived && allowedToUpdate"
            mat-flat-button
            type="button"
            color="warn"
            (click)="archiveErrorClicked()"
        >
            Archive error
        </button>
        <button
            *ngIf="errorIsArchived && allowedToUpdate"
            mat-flat-button
            type="button"
            color="primary"
            (click)="unarchiveErrorClicked()"
        >
            Unarchive error
        </button>
        <button
            *ngIf="allowedToUpdate"
            mat-flat-button
            type="submit"
            color="primary"
        >
            Update in Tracy
        </button>
    </div>
</form>
